import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import App from './App';
import NavigationProvider from './contexts';

function LLM(props) {
  const { match, ...appProps } = props;

  return (
    <NavigationProvider>
      <App {...appProps} />
    </NavigationProvider>
  );
}

LLM.propTypes = {
  match: PropTypes.objectOf(PropTypes.any).isRequired
};

export default withRouter(LLM);
